import React from "react";
import {PlayerCenterPlayIcon} from "../Icons";
import "./style.scss";

export const Button = ({onClick, children}) => {
    return (
        <button className="stream-player-centerButton" onClick={onClick}>
            {children}
        </button>
    );
}

export default ({ playerRef }) => {
    const video = playerRef.current;

    if (!video) {
        return null;
    }

    const handlePlay = () => {
        try {
           video.play() 
        } catch (e) {
            console.info(e)
        }
    }

    return (
        <Button onClick={handlePlay}>
            <PlayerCenterPlayIcon />
        </Button>
    );
}
